import { type Ref, computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import translations from './useProductHeadDescription.translations'

export function useProductHeadDescription({
  productResponse,
}: {
  productResponse: Ref<GetProductResponse | null>
}) {
  const i18n = useI18n()
  const { features } = useMarketplace()

  const description = computed(() => {
    if (!productResponse.value) {
      return ''
    }

    return i18n(translations.description, {
      title: productResponse.value.titles.default,
      warrantyDuration: features.warranty.duration,
      coolingOffDays: features.coolingOffDays,
      category: productResponse.value.tracking.categoryName,
      brand: productResponse.value.brand,
      model: productResponse.value.model,
    })
  })

  return { description }
}
